<template>
  <!-- 班级二维码 -->
  <div class="my-gradeCode">
    <div class="qr">
      <div class="qr-tips">扫码加入班级</div>
      <div class="code-head">
        <p class="qr-title">{{ className }}</p>
      </div>
      <QrCode :qrUrl="qrCodeUrl" ref="qrcode"></QrCode>
    </div>
    <div class="delModel" v-if="isCodeModel">
      <div class="model-dissolve">
        <p class="head">提示</p>
        <p class="title">{{ message }}</p>
        <div class="dissolve-box" v-if="closeBtn">
          <div class="btn-close" @click="handleClose">关闭</div>
        </div>
        <div class="dissolve-box" v-else>
          <div class="btnclose" @click="handleHome">取消</div>
          <div class="btn0k" @click="handleOk">确认</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {Toast} from 'vant'
import {classroomDetails, joinClassRoom, classUserPermissions} from '@/api/grade'
import QrCode from '@/components/QrCode'
import {debounce} from '@/utils/util'
import withRouteTracking from '@/utils/withRouteTracking'

const UserProfile = {
  name: 'gradeCode',
  components: {
    QrCode
  },
  data() {
    return {
      qrCodeUrl: '',
      classId: '',
      className: '',
      isCodeModel: false,
      message: '',
      closeBtn: false,
      permissions: {},
      btnType: false,
      type: '',
    }
  },
  computed: {
    userId() {
      return this.$store.getters.userInfo
    },
  },
  async created() {
    this.classId = this.$route.query.classId
    this.type = this.$route.query.type
    this.qrCodeUrl = `/gradeInterpage?classId=${this.classId}&sourceShare=1`
    // this.qrCodeUrl = `/gradeHomePage?classId=${this.classId}&sourceShare=1`
    if (this.classId) {
      const params = {
        classId: this.classId
      }
      const {data} = await classroomDetails(params)
      this.className = data.className
      if (this.type === 'gradeDetails') { // 从页面详情进来不做任何操作
        return
      }
      if (this.userId.memberType === 1) { // 员工
        return this.handlePage()
      } else { // 术者
        await this.getClassUserPermissions()
      }
    }
  },
  methods: {
    handlePage() {
      this.$router.push({
        path: '/gradeHomePage',
        query: {
          classId: this.classId
        }
      })
    },
    // 获取用户班级角色权限
    getClassUserPermissions() {
      const params = {
        classId: this.classId,
        userId: this.userId.id
      }
      classUserPermissions(params).then(res => {
        const data = res.data
        this.permissions = data
        if (!data.inClassList) { // 不在班级名单内
          this.handleMsg('您目前不在该班级成员名单内，暂不能加入，如有需要请联系强生员工。')
          this.btnType = true
        } else if (data.roleType === 3) { // 班级学员
          if (data.userStatus === 2) { // 已邀请
            this.isCodeModel = true
            this.closeBtn = false
            this.message = `确认加入【${this.className}】吗？`
          } else { // 已加入
            this.handlePage()
          }
        } else {
          this.handleMsg('仅术者可扫码加入')
        }
      })
    },
    handleMsg(msg) {
      this.message = msg
      this.isCodeModel = true
      this.closeBtn = true
      // this.handlePage()
    },
    // 扫码拿到当前用户的ID，根据当前用户的ID和用户或者管理员进行匹配
    // 班级详情
    async handleClassroomDetails() {
      const params = {
        classId: this.classId
      }
      await classroomDetails(params).then(res => res.data.className)
    },
    handleOk: debounce(function () {
      const params = {
        classId: this.classId,
        userId: this.userId.id
      }
      joinClassRoom(params).then(res => {
        const data = res.data
        if (data.code === 'Success') {
          Toast('已加入成功')
          this.handlePage()
        }
      })
    }, 500),
    handleHome() {
      this.$router.push({
        path: '/home'
      })
    },
    handleClose() {
      if (this.btnType) {
        this.handleHome()
      } else {
        this.handlePage()
      }
    },
  }
}
export default withRouteTracking(UserProfile)
</script>

<style lang="less" scoped>
.my-gradeCode {
  position: relative;
  background: #F9F8F7;
  padding: 20px;
  height: 100vh;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;

  .qr {
    height: 456px;
    background: #fff;
    border-radius: 12px;
    padding: 36px 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;

    .qr-tips {
      color: #000;
      font-family: PingFang SC;
      font-size: 24px;
      font-weight: 600;
      margin-bottom: 10px;
    }

    .code-head {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 23px;
      width: 100%;

      .qr-title {
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 600;
        font-size: 24px;
        color: #000000;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .qr-url {
      padding: 0 9px;
      width: 256px;
      height: 256px;
      margin-bottom: 16px;
    }
  }

  .delModel {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1;
    background: rgba(0, 0, 0, 0.5);
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 26px;

    .model-dissolve {
      position: absolute;
      left: 50%;
      top: 50%;
      margin-left: -160px;
      margin-top: -98px;
      background: #fff;
      width: 320px;
      height: 195px;
      border-radius: 15px;
      padding: 15px 17px 16px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;

      .head {
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 600;
        font-size: 17px;
        color: #000000;
        line-height: 20px;
        margin-bottom: 20px;
        text-align: center;
      }

      .title {
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 400;
        font-size: 16px;
        color: rgba(0, 0, 0, 0.8);
        line-height: 21px;
        margin: 0 14px;
        text-align: center;
        flex: 1;
        display: -webkit-box;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
      }

      .dissolve-box {
        margin-top: 16px;
        display: flex;
        align-items: center;

        .btn-close {
          height: 42px;
          flex: 1;
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 400;
          font-size: 16px;
          color: #EB1700;
          line-height: 41px;
          text-align: center;
          background: rgba(235, 23, 0, 0.08);
          border-radius: 20px 20px 20px 20px;
        }

        .btnclose {
          flex: 1;
          height: 42px;
          background: #F1EFED;
          border-radius: 20px;
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 400;
          font-size: 16px;
          color: #81766F;
          line-height: 42px;
          text-align: center;
        }

        .btn0k {
          margin-left: 27px;
          flex: 1;
          height: 42px;
          background: #EB1700;
          box-shadow: 0px 2px 4px 0px rgba(255, 91, 12, 0.25);
          border-radius: 22px;
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 400;
          font-size: 16px;
          color: #FFFFFF;
          line-height: 42px;
          text-align: center;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/grade/components/gradeCode.vue